// Soft UI Dashboard PRO React base styles
import borders from 'src/theme/base/borders';

// Soft UI Dashboard PRO React helper functions
import pxToRem from 'src/theme/functions/pxToRem';

const { borderRadius } = borders;

const tableHead = {
  styleOverrides: {
    root: {
      display: 'block',
      padding: `${pxToRem(16)} ${pxToRem(16)} 0  ${pxToRem(16)}`,
      borderRadius: `${borderRadius.xl} ${borderRadius.xl} 0 0`,
    },
  },
};

export default tableHead;
